(function() {
    'use strict';

    angular
        .module('receiptApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', '$urlRouterProvider', 'CONST_RECEIPT', '$base64', 'GLOBAL_URL'];

    function stateConfig($stateProvider, $urlRouterProvider, CONST_RECEIPT, $base64, GLOBAL_URL) {
    	$urlRouterProvider.otherwise("/individual");
    	
    	$stateProvider.state(CONST_RECEIPT.STATE_RECEIPT, {
    		  data: {
              	pageTitle: CONST_RECEIPT.PROPOSAL_PAGE_TITLE
              },
              views: {
              	'content@': {
                      templateUrl: GLOBAL_URL + 'partial?uri=ga/receipt/receipt',  
                      controller: 'ReceiptController as receiptCtr'
                   }
              }
              
    	})
    	.state(CONST_RECEIPT.STATE_PROPOSAL, {
            data: {
            	pageTitle: CONST_RECEIPT.PROPOSAL_PAGE_TITLE
            },
            views: {
                'partial@receipt': {
                    template: '<div ui-view="partial"></div>',
                }
            }
        }).state(CONST_RECEIPT.STATE_INDIVIDUAL, {
            url: '/individual/:txnId/:taskId/:etrrbReceiptId',
            data: {
            	pageTitle: CONST_RECEIPT.PROPOSAL_INDIVIDUAL_PAGE_TITLE
            },
            params: { 
            	txnId: {squash: true, value: null }, 
            	taskId: {squash: true, value: null },
            	etrrbReceiptId: {squash: true, value: null }
            },
            views: {
                'partial@receipt.proposal': {
                    templateUrl: GLOBAL_URL + 'partial?uri=ga/receipt/proposal/individual/individual',
                    controller: 'ProposalController as proposalCtr'
                }
            },
            resolve : {
            	entity: function(ReceiptService, $stateParams){	
        			if($stateParams.txnId != null && $stateParams.txnId != undefined){
        				return ReceiptService.get({uri:"get-receipt", txnId:$base64.decode($stateParams.txnId)}).$promise            			
        			}else if($stateParams.etrrbReceiptId != null && $stateParams.etrrbReceiptId != undefined){
        				return ReceiptService.get({uri:"get-receipt-for-etrrb", etrrbReceiptId:$base64.decode($stateParams.etrrbReceiptId)}).$promise            			
        			}else{
        				return null;
        			}
        			
        		},
        		mode:function($stateParams) {
        			if($stateParams.taskId != null && $stateParams.taskId != undefined){
        				return false;
        			}
        			return true;
        		}
        	}
            
        }).state(CONST_RECEIPT.STATE_CORPORATION, {
            url: '/corporation/:txnId/:taskId/:etrrbReceiptId',
            data: {
            	pageTitle: CONST_RECEIPT.PROPOSAL_CORPORATION_PAGE_TITLE
            },
            views: {
                'partial@receipt.proposal': {
                    templateUrl: GLOBAL_URL + 'partial?uri=ga/receipt/proposal/corporation/corporation',
                    controller: 'ProposalController as proposalCtr'
                }
            },
            params: { 
            	txnId: {squash: true, value: null }, 
            	taskId: {squash: true, value: null },
            	etrrbReceiptId: {squash: true, value: null }
            },
            resolve : {
            	entity: function(ReceiptService, $stateParams){	
        			if($stateParams.txnId != null && $stateParams.txnId != undefined){
        				return ReceiptService.get({uri:"get-receipt", txnId:$base64.decode($stateParams.txnId)}).$promise            			
        			}else if($stateParams.etrrbReceiptId != null && $stateParams.etrrbReceiptId != undefined){
        				return ReceiptService.get({uri:"get-receipt-for-etrrb", etrrbReceiptId:$base64.decode($stateParams.etrrbReceiptId)}).$promise            			
        			}else{
        				return null;
        			}
        		},
        		mode:function($stateParams) {
        			if($stateParams.taskId != null && $stateParams.taskId != undefined){
        				return false;
        			}
        			return true;
        		}
        	}
        }).state(CONST_RECEIPT.STATE_CONTEST, {
            url: '/contest-payment',
            data: {
            	pageTitle: CONST_RECEIPT.CONTEST_PAYMENT_PAGE_TILE
            },
            views: {
                'partial@receipt.proposal': {
                    templateUrl: GLOBAL_URL + 'partial?uri=ga/receipt/proposal/contest/contest-payment',  
                    controller: 'ContestPaymentController as contestPaymentCtr'
                }
            }
        })
        .state(CONST_RECEIPT.STATE_POLICY, {
            url: '/policy/:txnId/:taskId/:etrrbReceiptId',
            params: { 
            	txnId:  {squash: true, value: null },
            	taskId: {squash: true, value: null },
            	etrrbReceiptId: {squash: true, value: null }
            },
            data: {
            	pageTitle: CONST_RECEIPT.POLICY_PAGE_TITLE
            },
            views: {
                'partial@receipt': {
                    templateUrl: GLOBAL_URL + 'partial?uri=ga/receipt/policy/policy',  
                    controller: 'PolicyController as policyCtr'
                }
            },
            resolve : {
            	entity: function(ReceiptService, $stateParams){	
        			if($stateParams.txnId != null && $stateParams.txnId != undefined){
        				var receipt =  ReceiptService.get({uri:"get-receipt", txnId:$base64.decode($stateParams.txnId)}).$promise;
        				return receipt;
        			}else if($stateParams.etrrbReceiptId != null && $stateParams.etrrbReceiptId != undefined){
        				return ReceiptService.get({uri:"get-receipt-for-etrrb", etrrbReceiptId:$base64.decode($stateParams.etrrbReceiptId)}).$promise            			
        			}else{
        				return null;
        			}
        		},
        		policy: function(entity, PolicyService){
        			if(entity != null && entity.transaction != null && entity.transaction.policyNum != null){
        				return PolicyService.getPolicyByPolicyNum({method:'getPolicyByPolicyNum',policyNum:entity.transaction.policyNum,clientIdNum:'' }).$promise;
        			}else{
        				return null;
        			}
        		},
        		mode: function($stateParams){
        			if($stateParams.taskId != null && $stateParams.taskId != undefined){
        				return false;
        			}
        			return true;
        		}
        	}
        })
        .state(CONST_RECEIPT.STATE_POLICY_REVERSAL, {
            url: '/policy-reversal/:txnId/:taskId',
            params: { 
            	txnId:  {squash: true, value: null },
            	taskId: {squash: true, value: null }
            },
            data: {
            	pageTitle: CONST_RECEIPT.POLICY_PAGE_TITLE
            },
            views: {
                'partial@receipt': {
                    templateUrl: GLOBAL_URL + 'partial?uri=ga/receipt/policy/policy-reversal',  
                    controller: 'PolicyController as policyCtr'
                }
            },
            resolve : {
            	entity: function(ReceiptService, $stateParams){	
        			if($stateParams.txnId != null && $stateParams.txnId != undefined){
        				var receipt =  ReceiptService.get({uri:"get-receipt", txnId:$base64.decode($stateParams.txnId)}).$promise;
        				return receipt;
        			}else{
        				return null;
        			}
        		},
        		policy: function(entity, PolicyService){
        			if(entity != null && entity.transaction != null && entity.transaction.policyNum != null){
        				return PolicyService.getPolicyByPolicyNum({method:'getPolicyByPolicyNum',policyNum:entity.transaction.policyNum,clientIdNum:'' }).$promise;
        			}else{
        				return null;
        			}
        		},
        		mode: function($stateParams){
        			if($stateParams.taskId != null && $stateParams.taskId != undefined){
        				return false;
        			}
        			return true;
        		}
        	}
        })
    }
})();
